var simplemaps_usmap_mapdata={
    main_settings: {
     //General settings
      width: "responsive", //'700' or 'responsive'
      background_color: "#fbf8f1",
      background_transparent: "no",
      border_color: "#234e70",
      popups: "detect",
      state_description: "",
      state_color: "#F3EEE3",
      state_hover_color: "",
      state_url: "",
      border_size: "0.75",
      all_states_inactive: "no",
      all_states_zoomable: "no",
      
      //Location defaults
      location_description: "Add location markers using latitude and longitude!",
      location_color: "#234e70",
      location_opacity: "1",
      location_hover_opacity: 1,
      location_url: "",
      location_size: "16",
      location_type: "circle",
      location_image_source: "frog.png",
      location_border_color: "#FFFFFF",
      location_border: 2,
      location_hover_border: 2.5,
      all_locations_inactive: "no",
      all_locations_hidden: "no",
      
      //Label defaults
      label_color: "#d5ddec",
      label_hover_color: "#d5ddec",
      label_size: 22,
      label_font: "Arial",
      hide_labels: "no",
      hide_eastern_labels: "no",
      manual_zoom: "no",
      back_image: "no",
      initial_back: "no",
      initial_zoom: -1,
      initial_zoom_solo: "no",
      region_opacity: 1,
      region_hover_opacity: 0.6,
      zoom_out_incrementally: "yes",
      zoom_percentage: 0.99,
      zoom_time: 0.5,
      
      //Popup settings
      popup_color: "white",
      popup_opacity: 0.9,
      popup_shadow: 1,
      popup_corners: 5,
      popup_font: "12px/1.5 Verdana, Arial, Helvetica, sans-serif",
      popup_nocss: "no",
      
      //Advanced settings
      div: "map",
      auto_load: "yes",
      url_new_tab: "yes",
      images_directory: "/static/lib/simplemaps/map_images/",
      fade_time: 0.1,
      import_labels: "no",
      link_text: "View Website",
      state_image_url: "",
      state_image_position: "",
      location_image_url: "",
      border_hover_color: "",
      border_hover_size: "1.25"
    },
    state_specific: {
      HI: {
        name: "Hawaii",
        hover_color: "#E3DBC8"
      },
      AK: {
        name: "Alaska",
        hover_color: "#E3DBC8"
      },
      FL: {
        name: "Florida",
        hover_color: "#E3DBC8"
      },
      NH: {
        name: "New Hampshire",
        inactive: "yes"
      },
      VT: {
        name: "Vermont",
        inactive: "yes"
      },
      ME: {
        name: "Maine",
        hover_color: "#E3DBC8"
      },
      RI: {
        name: "Rhode Island",
        inactive: "yes"
      },
      NY: {
        name: "New York",
        inactive: "yes"
      },
      PA: {
        name: "Pennsylvania",
        inactive: "yes"
      },
      NJ: {
        name: "New Jersey",
        inactive: "yes"
      },
      DE: {
        name: "Delaware",
        inactive: "yes"
      },
      MD: {
        name: "Maryland",
        inactive: "yes"
      },
      VA: {
        name: "Virginia",
        hover_color: "#E3DBC8"
      },
      WV: {
        name: "West Virginia",
        hover_color: "#E3DBC8"
      },
      OH: {
        name: "Ohio",
        hover_color: "#E3DBC8"
      },
      IN: {
        name: "Indiana",
        hover_color: "#E3DBC8"
      },
      IL: {
        name: "Illinois",
        inactive: "yes"
      },
      CT: {
        name: "Connecticut",
        inactive: "yes"
      },
      WI: {
        name: "Wisconsin",
        inactive: "yes"
      },
      NC: {
        name: "North Carolina",
        inactive: "yes"
      },
      DC: {
        name: "District of Columbia",
        inactive: "yes"
      },
      MA: {
        name: "Massachusetts",
        inactive: "yes"
      },
      TN: {
        name: "Tennessee",
        hover_color: "#E3DBC8"
      },
      AR: {
        name: "Arkansas",
        hover_color: "#E3DBC8"
      },
      MO: {
        name: "Missouri",
        hover_color: "#E3DBC8"
      },
      GA: {
        name: "Georgia",
        inactive: "yes"
      },
      SC: {
        name: "South Carolina",
        hover_color: "#E3DBC8"
      },
      KY: {
        name: "Kentucky",
        hover_color: "#E3DBC8"
      },
      AL: {
        name: "Alabama",
        inactive: "yes"
      },
      LA: {
        name: "Louisiana",
        inactive: "yes"
      },
      MS: {
        name: "Mississippi",
        inactive: "yes"
      },
      IA: {
        name: "Iowa",
        inactive: "yes"
      },
      MN: {
        name: "Minnesota",
        hover_color: "#E3DBC8"
      },
      OK: {
        name: "Oklahoma",
        inactive: "yes"
      },
      TX: {
        name: "Texas",
        hover_color: "#E3DBC8"
      },
      NM: {
        name: "New Mexico",
        hover_color: "#E3DBC8"
      },
      KS: {
        name: "Kansas",
        inactive: "yes"
      },
      NE: {
        name: "Nebraska",
        inactive: "yes"
      },
      SD: {
        name: "South Dakota",
        hover_color: "#E3DBC8"
      },
      ND: {
        name: "North Dakota",
        hover_color: "#E3DBC8"
      },
      WY: {
        name: "Wyoming",
        hover_color: "#E3DBC8"
      },
      MT: {
        name: "Montana",
        hover_color: "#E3DBC8"
      },
      CO: {
        name: "Colorado",
        hover_color: "#E3DBC8"
      },
      UT: {
        name: "Utah",
        hover_color: "#E3DBC8"
      },
      AZ: {
        name: "Arizona",
        hover_color: "#E3DBC8"
      },
      NV: {
        name: "Nevada",
        hover_color: "#E3DBC8"
      },
      OR: {
        name: "Oregon",
        hover_color: "#E3DBC8"
      },
      WA: {
        name: "Washington",
        hover_color: "#E3DBC8"
      },
      CA: {
        name: "California",
        hover_color: "#E3DBC8"
      },
      MI: {
        name: "Michigan",
        hover_color: "#E3DBC8"
      },
      ID: {
        name: "Idaho",
        inactive: "yes"
      },
      GU: {
        name: "Guam",
        hide: "yes"
      },
      VI: {
        name: "Virgin Islands",
        hide: "no",
        hover_color: "#E3DBC8"
      },
      PR: {
        name: "Puerto Rico",
        hide: "yes"
      },
      MP: {
        name: "Northern Mariana Islands",
        hide: "yes"
      },
      AS: {
        name: "American Samoa",
        hide: "no",
        hover_color: "#E3DBC8"
      }
    },
    locations: {
      "0": {
        lat: 42.912,
        lng: -122.148,
        name: "Crater Lake",
        url: "https://makeyourpuzzles.com/products/crater-lake-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Crater_Lake_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753623164",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "1": {
        lat: 43.791,
        lng: -101.905,
        name: "Badlands",
        url: "https://makeyourpuzzles.com/products/badlands-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Badlands_National_Park_Puzzle_River_by_MakeYourPuzzles_section.webp?v=1768401451",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "2": {
        lat: 29.328,
        lng: -103.206,
        name: "Big Bend",
        url: "https://makeyourpuzzles.com/products/big-bend-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Big_Bend_National_Puzzle_by_MakeYourPuzzles_section.webp?v=1768401472",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "3": {
        lat: 44.339,
        lng: -68.183,
        name: "Acadia",
        url: "https://makeyourpuzzles.com/products/acadia-national-park-lighthouse-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Acadia_National_Park_Puzzle_Summertime_by_MakeYourPuzzles.webp?v=1753628141",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "4": {
        lat: "37.555",
        lng: "-120.3",
        name: "California National Parks",
        url: "https://makeyourpuzzles.com/collections/california-national-parks-puzzles",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/California_National_Parks_Collage_Jigsaw_Puzzle_9_Parks_by_MakeYourPuzzles.webp?v=1754339969",
        popup_type: "collection",
        collection_park_count: 9,
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Collection →",
        size: "24",
        color: "#00A79D"
      },
      "5": {
        name: "Alaska National Parks",
        lat: 63.732,
        lng: "-148.892",
        url: "https://makeyourpuzzles.com/collections/alaska-national-parks-puzzles",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Alaska_National_Parks_Collage_Puzzle_by_MakeYourPuzzles.webp?v=1753637257",
        popup_type: "collection",
        collection_park_count: 8,
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Collection →",
        size: "24",
        color: "#00A79D"
      },
      "6": {
        name: "Utah National Parks",
        lat: 39.601,
        lng: -110.811,
        url: "https://makeyourpuzzles.com/collections/utah-national-parks-puzzles",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Utah_National_Parks_Puzzle_Collage_by_MakeYourPuzzles.webp?v=1754399745",
        popup_type: "collection",
        collection_park_count: 5,
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Collection →",
        size: "24",
        color: "#00A79D"
      },
      "7": {
        lat: 38.834,
        lng: -104.822,
        name: "Colorado National Parks",
        url: "https://makeyourpuzzles.com/collections/colorado-national-parks-puzzles",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Colorado_National_Parks_Collage_Puzzle.webp?v=1754363560",
        popup_type: "collection",
        collection_park_count: 4,
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Collection →",
        size: "24",
        color: "#00A79D"
      },
      "8": {
        lat: "27.955",
        lng: "-85.232",
        name: "Virgin Islands",
        url: "https://makeyourpuzzles.com/products/virgin-islands-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Virgin_Islands_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753627252",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "9": {
        lat: "25.60",
        lng: "-85.9",
        name: "American Samoa",
        url: "https://makeyourpuzzles.com/products/national-park-of-american-samoa-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/National_Park_Of_American_Samoa_Puzzle_by_MakeYourPuzzles.webp?v=1753626002",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "10": {
        name: "Biscayne",
        lat: 25.166,
        lng: -80.378,
        url: "https://makeyourpuzzles.com/products/biscayne-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Biscayne_National_Park_Puzzle_Sandbars_by_MakeYourPuzzles.webp?v=1753622432",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "11": {
        lat: "32.5",
        lng: -104.442,
        name: "Carlsbad Caverns",
        url: "https://makeyourpuzzles.com/products/carlsbad-caverns-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Carlsbad_Caverns_National_Puzzle_by_MakeYourPuzzles.webp?v=1753622838",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "12": {
        lat: 33.831,
        lng: -80.823,
        name: "Congaree",
        url: "https://makeyourpuzzles.com/products/congaree-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Congaree_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753623068",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "13": {
        lat: 41.263,
        lng: -81.561,
        name: "Cuyahoga Valley",
        url: "https://makeyourpuzzles.com/products/cuyahoga-valley-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Cuyahoga_National_Park_Puzzle_Brandywine_Falls_by_MakeYourPuzzles.webp?v=1753623281",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "14": {
        name: "Dry Tortugas",
        lat: 24.555,
        lng: -81.8,
        url: "https://makeyourpuzzles.com/products/dry-tortugas-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Dry_Tortugas_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753623466",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "15": {
        lat: 25.396,
        lng: "-81.111",
        name: "Everglades",
        url: "https://makeyourpuzzles.com/products/everglades-national-park-blue-heron-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Everglades_National_Park_Puzzle_Blue_Heron_by_MakeYourPuzzles.webp?v=1753631181",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "16": {
        lat: 38.625,
        lng: -90.185,
        name: "Gateway Arch",
        url: "https://makeyourpuzzles.com/products/gateway-arch-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Gateway_Arch_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753623693",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "17": {
        lat: 48.697,
        lng: -113.72,
        name: "Glacier National Park",
        url: "https://makeyourpuzzles.com/products/glacier-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Glacier_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753623815",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "18": {
        lat: 36.048,
        lng: -112.13,
        name: "Grand Canyon",
        url: "https://makeyourpuzzles.com/products/grand-canyon-mather-point-jigsaw-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Grand_Canyon_National_Park_Puzzle_Mather_Point_by_MakeYourPuzzles.webp?v=1753628327",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "19": {
        lat: 43.867,
        lng: -110.572,
        name: "Grand Teton",
        url: "https://makeyourpuzzles.com/products/grand-teton-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Grand_Teton_National_Park_Puzzle_by_MakeYourPuzzles_product_2048.webp?v=1753795562",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "20": {
        lat: 39.006,
        lng: -114.22,
        name: "Great Basin",
        url: "https://makeyourpuzzles.com/products/great-basin-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Great_Basin_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624017",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "21": {
        lat: 35.685,
        lng: -83.537,
        name: "Great Smoky Mountains",
        url: "https://makeyourpuzzles.com/products/great-smoky-mountains-national-park-puzzle-deer",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Great_Smoky_Mountains_National_Park_Puzzle_White_Tailed_Deer_by_MakeYourPuzzles.webp?v=1753629508",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "22": {
        lat: "31.6",
        lng: -104.821,
        name: "Guadalupe Mountains",
        url: "https://makeyourpuzzles.com/products/guadalupe-mountains-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Guadalupe_Mountains_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624231",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "23": {
        lat: 20.76,
        lng: -156.246,
        name: "Haleakala",
        url: "https://makeyourpuzzles.com/products/haleakala-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Haleakala_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624332",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "24": {
        lat: 19.429,
        lng: -155.255,
        name: "Hawaii Volcanoes",
        url: "https://makeyourpuzzles.com/products/hawai-i-volcanoes-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Hawaii_Volcanoes_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624391",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "25": {
        lat: 34.518,
        lng: -93.045,
        name: "Hot Springs",
        url: "https://makeyourpuzzles.com/products/hot-springs-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Hot_Springs_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624473",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "26": {
        name: "Indiana Dunes",
        lat: 41.719,
        lng: -86.903,
        url: "https://makeyourpuzzles.com/products/indiana-dunes-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Indiana_Dunes_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624543",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "27": {
        name: "Isle Royale",
        lat: "48.217",
        lng: "-89",
        url: "https://makeyourpuzzles.com/products/isle-royale-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Isle_Royale_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753624606",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "28": {
        lat: 37.187,
        lng: -86.101,
        name: "Mammoth Cave",
        url: "https://makeyourpuzzles.com/products/mammoth-cave-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Mammoth_Cave_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753625803",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "29": {
        lat: 46.741,
        lng: -121.917,
        name: "Mount Rainier",
        url: "https://makeyourpuzzles.com/products/mount-rainier-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Mount_Rainier_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753625921",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "30": {
        lat: 37.783,
        lng: -80.897,
        name: "New River Gorge",
        url: "https://makeyourpuzzles.com/products/new-river-gorge-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/New_River_Gorge_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753626069",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "31": {
        lat: 48.666,
        lng: -121.267,
        name: "North Cascades",
        url: "https://makeyourpuzzles.com/products/north-cascades-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/North_Cascades_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753626127",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "32": {
        lat: 48.1,
        lng: -123.425,
        name: "Olympic",
        url: "https://makeyourpuzzles.com/products/olympic-national-park-puzzle-rainforest",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Olympic_National_Park_Puzzle_Hurricane_Ridge_by_MakeYourPuzzles.webp?v=1753630522",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "33": {
        lat: 35.067,
        lng: -109.782,
        name: "Petrified Forest",
        url: "https://makeyourpuzzles.com/products/petrified-forest-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Petrified_Forest_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753626235",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "34": {
        lat: 32.181,
        lng: -110.737,
        name: "Saguaro",
        url: "https://makeyourpuzzles.com/products/saguaro-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Saguaro_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753626990",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "35": {
        lat: 38.906,
        lng: -78.198,
        name: "Shenandoah",
        url: "https://makeyourpuzzles.com/products/shenandoah-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Shenandoah_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753627110",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "36": {
        lat: 46.916,
        lng: -103.526,
        name: "Theodore Roosevelt National Park",
        url: "https://makeyourpuzzles.com/products/theodore-roosevelt-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Theodore_Roosevelt_National_Park_Puzzle_Winter_by_MakeYourPuzzles.webp?v=1753631055",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "37": {
        lat: 48.585,
        lng: -93.161,
        name: "Voyageurs",
        url: "https://makeyourpuzzles.com/products/voyageurs-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Voyageurs_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753627307",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "38": {
        lat: 32.78,
        lng: -106.173,
        name: "White Sands",
        url: "https://makeyourpuzzles.com/products/white-sands-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/White_Sands_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753627359",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "39": {
        lat: 43.557,
        lng: -103.474,
        name: "Wind Cave",
        url: "https://makeyourpuzzles.com/products/wind-cave-national-park-puzzle",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Wind_Cave_National_Park_Puzzle_by_MakeYourPuzzles.webp?v=1753627415",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      },
      "40": {
        lat: "44.70",
        lng: -110.666,
        name: "Yellowstone",
        url: "https://makeyourpuzzles.com/products/yellowstone-national-park-puzzle-bison",
        popup: "off",
        description: "",
        image_url: "https://cdn.shopify.com/s/files/1/0118/7843/2830/files/Yellowstone_National_Park_Puzzle_Bison_by_MakeYourPuzzles.webp?v=1753627660",
        popup_type: "park",
        popup_subtitle: "National Park Puzzle",
        popup_detail: "From 48 to 1000 Pieces",
        popup_cta: "Explore Puzzle →"
      }
    },
    labels: {},
    legend: {
      entries: []
    },
    regions: {}
  };
